import React, { useState, useEffect,useRef  } from "react";
import { useMediaQuery } from 'react-responsive';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";



// import { Swiper, SwiperSlide } from 'swiper/react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';



const fullImageSliderSettings = {
  autoplay: true,
  autoplaySpeed: 5000, // 5 seconds
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
};



// Reusable Feature Section Component
const FeatureSection = ({
  data,
  activeIndex,
  setActiveIndex,
  title,
  showToggle,
  showButton,
  toggleData,
  setToggleData,
}) => {
  const [progress, setProgress] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;

    setProgress(0);
    const progressInterval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + 1));
    }, 46);

    const switchSection = setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % data.length);
      setProgress(0);
    }, 4615);

    return () => {
      clearTimeout(switchSection);
      clearInterval(progressInterval);
    };
  }, [activeIndex, isPaused]);

  const handleClick = (index) => {
    setIsPaused(true);
    setActiveIndex(index);
    setProgress(0);
    setTimeout(() => setIsPaused(false), 100);
  };

  return (
    <div className="third">
      <div className="row">
        {/* Left Side Image */}
        <div className="col-lg-6 input">
        
            <img src={data[activeIndex].image} alt="" width={350} />
        </div>

        {/* Right Side Content */}
        <div className="col-lg-6">
          {/* Only show toggle buttons in the second section */}
          {showToggle && (
            <div className="toggle-head d-flex">
              <p
                className={`toggle-option ${
                  toggleData === "integration" ? "active" : ""
                }`}
                onClick={() => setToggleData("integration")}
              >
                INTEGRATION
              </p>
              <p
                className={`toggle-option ${
                  toggleData === "technology" ? "active" : ""
                }`}
                onClick={() => setToggleData("technology")}
              >
                TECHNOLOGY
              </p>
            </div>
          )}

          <div className="input-text">
           
              <h1>{title}</h1>
         
            
            <div className="info">
              {data.map((item, index) => (
           
                <div
                  key={index}
                  className={`section ${activeIndex === index ? "active" : ""}`}
                >
                  <p
                    className={`head ${activeIndex === index ? "active" : ""}`}
                    onClick={() => handleClick(index)}
                  >
                    {item.title}
                  </p>
                  <div
                    className={`progress-bar ${
                      activeIndex === index ? "active" : ""
                    }`}
                    style={{
                      width: `${activeIndex === index ? progress : 0}%`,
                    }}
                  ></div>
                  {activeIndex === index && (
                    <p className="body">{item.content}</p>
                  )}
                </div>
             
              ))}

              {/* Only show button in the first section */}
              {showButton && (
              
                  <div className="btn">
                    <a href="https://apps.shopify.com/kwikpass">
                      <button className="cta2">
                        <img
                          src="/assets/images/kwikpass/shopw.png"
                          alt="Shopify Logo"
                          width={20}
                        />
                        Get It On Shopify
                      </button>
                    </a>
                  </div>
              
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SectionTwo = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [secondIndex, setSecondIndex] = useState(0);
  const [toggleData, setToggleData] = useState("integration");
  const cardsRef = useRef(null);

 const isMobile = useMediaQuery({ maxWidth: 768 });


  const sections = [
    {
      title: "Seamless Phone-First Login",
      content:
        "Allow customers to quickly log in via OTP—no password needed—for a frictionless and secure shopping experience.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Smart Marketing Pop-Ups",
      content:
        "Engage customers with interactive pop-ups triggered based on their behavior, displaying personalized offers at the right moment.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Zero-click Anonymous User Identification",
      content:
        "Identify up to 25% anonymous visitors with 99.99% accuracy using advanced fingerprinting and GoKwik's proprietary user matching algorithms—powered by the most secure website visitor tracking software.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Data Capture at Every Touchpoint",
      content:
        "Track where users drop off and retarget them effectively. Collect emails, DOB, and more to personalize campaigns with insights from Kwik Pass visitor tracking app on Shopify.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Customizable Consent Management",
      content:
        "Capture and relay customer consent to Shopify seamlessly. Choose between opt-in, opt-out, or compulsory consent—putting you in control of data privacy while ensuring compliance and transparency.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Compare Your Stats with Industry Benchmarks",
      content:
        "Analyze how your data collection and engagement rates compare to industry standards to optimize performance and strategy.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Integrate & Retarget with KwikEngage",
      content:
        "Combine with Kwik Engage to launch targeted WhatsApp, SMS, and email campaigns that recover lost sales by targeting anonymous users.",
      image: "/assets/images/kwikpass/input.png",
    },
  ];


  const second = [
    {
      title: "Recognize & Retarget Instantly",
      content:
        "Identify anonymous & returning visitors for hyper-personalized engagement.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Automate Retargeting",
      content:
        "Trigger WhatsApp, SMS & email campaigns in real-time based on user actions.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Recover Abandoned Carts",
      content:
        "Instantly reach out with targeted offers when a user drops off.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Enhance Customer Retention",
      content:
        "Use deep insights to re-engage customers and drive repeat purchases.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "Drive Higher Conversions",
      content:
        "Leverage AI-driven segmentation and personalized messaging for better sales.",
      image: "/assets/images/kwikpass/input.png",
    },
  ];

  const tech = [
    {
      title: "Advanced User Recognition",
      content: "Fingerprint tracking & intelligent identification.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "	Analytics & Insights",
      content:
        " Google Analytics & Meta integration for deep performance tracking.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "	Seamless Data Sync",
      content: "Direct integrations with leading CRM & marketing platforms.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "	Rewards & Loyalty",
      content: "Collaborate with reward partners to drive repeat purchases.",
      image: "/assets/images/kwikpass/input.png",
    },
    {
      title: "	Universal Compatibility",
      content:
        "Integrate with custom-built stores, Shopify stores, and custom FE Shopify stores with Shopify customer data platform capabilities.",
      image: "/assets/images/kwikpass/input.png",
    },
  ];


  const sections1 = [
    {id:1,image:"/assets/images/kwikpass/group1.png"},
    {id:2,image:"/assets/images/kwikpass/group2.png"},
    {id:3,image:"/assets/images/kwikpass/group3.png"},
    {id:4,image:"/assets/images/kwikpass/group4.png"},
    {id:5,image:"/assets/images/kwikpass/group5.png"}
  ];

  const [activeIndex1, setActiveIndex1] = useState(0);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollTop = window.scrollY;
  //     const sectionHeight = window.innerHeight;
  //     const newIndex = Math.min(
  //       Math.floor(scrollTop / sectionHeight),
  //       sections.length - 1
  //     );
  //     setActiveIndex1(newIndex);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);
  
  const settingsmob = {
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "40px",
    arrows: false, // Hide default arrows
    dots: false,   // Hide navigation dots
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
    ],
  };


  // useEffect(() => {
  //   // Only run this effect on the client side
  //   if (typeof window !== 'undefined') {
  //     const tl = gsap.timeline({
  //       scrollTrigger: {
  //         trigger: ".cards",
  //         pin: true,
  //         pinSpacing: true,
  //         markers: true,
  //         start: "top top",
  //         end: "+=1000",
  //         scrub: 1
  //       }
  //     });

  //     tl.from(".card1", {
  //       yPercent: 100,
  //       opacity: 0
  //     });
  //     tl.from(".card2", {
  //       yPercent: 200,
  //       opacity: 0
  //     });
  //     tl.from(".card3", {
  //       yPercent: 200,
  //       opacity: 0
  //     });

  //     // Cleanup function
  //     return () => {
  //       tl.kill();
  //       ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  //     };
  //   }
  // }, []);

  


  return (
    <div className="section-2">
      <div className="container-fluid">
        
          <div className="top-text">
            <h1>GoKwik Network Effect</h1>

            {
              isMobile ? 
              <>
               <p>
              Leveraging the deepest pool of shoppers to build industry-best
              solutions  with AI-powered website visitor tracking tools
            </p>
              </>:
                <p>
                Leveraging the deepest pool of shoppers to build industry-best
                solutions <br/> with AI-powered website visitor tracking tools
              </p>
            }
          
          </div>
        

        {/* Key Metrics */}
  
          <div className="row d-flex justify-content-center mt-5">
            <div className="details">
              <div className="accurate d-flex same">
                <h1>25%</h1>
                {
                  isMobile ? <p >
                  of anonymous user
                  sessions identified
                  </p> :
                   <p className="mobile">
                   of anonymous user <br/>
                   sessions identified
                   </p>
                }
               
              </div>
              <div className="line"></div>
              <div className="d-flex same">
                <h1>5-10X</h1>
                <p>
                increase <br/>
                in ROAS
                </p>
              </div>
              <div className="line"></div>
              <div className="active d-flex same">
                <h1>130Mn+</h1>
                <p>
                shoppers on <br/>
                GoKwik network
                </p>
              </div>
            </div>
          </div>


        <div className="container-fulid fourth">
          
            <div className="top-text growth">
              <h1>Powering E-commerce Everywhere</h1>
              <p>
              Wherever You Sell, We Help You Identify & Engage More Shoppers.
              </p>
            </div>
 
     
        </div>

        <div className="container-fluid">

        <div className="container">
        <div className="layout-container">

            <div className="center-container">
                <div className="central-image d-none d-lg-block" >
                    <img src="/assets/images/kwikpass/secbtn.png" alt="KwikPass with Arrows" style={{height:"340px",width:"auto"}}/>
                </div>  
            </div>
            
     
            <div className="feature-box top d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/public.png" alt="Shopify" className="icon"/>
                </div>
                <h4>Shopify Public App</h4>
                <p>One-click integration for Shopify merchants to enable customer identification and engagement.</p>
            </div>
            
            <div className="feature-box top-right d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/store.png" alt="Custom Store" className="icon"/>
                </div>
                <h4>Shopify Custom Stores</h4>
                <p>Supports tailored Shopify implementations, ensuring seamless login and pop-up functionality.</p>
            </div>

            <div className="feature-box bottom-right d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/appmaker.png" alt="App" className="icon"/>
                </div>
                <h4>Appmaker & Appbrew</h4>
                <p>Enables brands using these platforms to enhance user identification and marketing pop-ups.</p>
            </div>
            
           
            <div className="feature-box bottom-left d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/customweb.png" alt="Website" className="icon"/>
                </div>
                <h4>Custom-Built Websites</h4>
                <p>Easily integrates with any proprietary website to power secure user authentication and engagement.</p>
            </div>
            
   
            <div className="feature-box top-left d-none d-lg-block">
                <div className="icon-container">
                    <img src="/assets/images/kwikpass/android.png" alt="Mobile" className="icon"/>
                </div>
                <h4>Android Mobile App</h4>
                <p>Extends seamless login and engagement capabilities to mobile-first businesses.</p>
            </div>
        </div>
        

        <div className="row feature-row d-lg-none">
            <div className="col-12 col-md-6">
                <div className="feature-box" >
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/public.png" alt="Shopify" className="icon"/>
                    </div>
                    <h4>Shopify Public App</h4>
                    <p>One-click integration for Shopify merchants to enable customer identification and engagement.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/store.png" alt="Custom Store" className="icon"/>
                    </div>
                    <h4>Shopify Custom Stores</h4>
                    <p>Supports tailored Shopify implementations, ensuring seamless login and pop-up functionality.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/appmaker.png" alt="App" className="icon"/>
                    </div>
                    <h4>Appmaker & Appbrew</h4>
                    <p>Enables brands using these platforms to enhance user identification and marketing pop-ups.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/customweb.png" alt="Website" className="icon"/>
                    </div>
                    <h4>Custom-Built Websites</h4>
                    <p>Easily integrates with any proprietary website to power secure user authentication and engagement.</p>
                </div>
            </div>
            
            <div className="col-12 col-md-6">
                <div className="feature-box">
                    <div className="icon-container">
                        <img src="/assets/images/kwikpass/android.png" alt="Mobile" className="icon"/>
                    </div>
                    <h4>Android Mobile App</h4>
                    <p>Extends seamless login and engagement capabilities to mobile-first businesses.</p>
                </div>
            </div>
        </div>
    </div>










      {/* Lines for the cross and diagonals */}
      {/* <div className="cross-lines ">
        <div className="vertical-line">
                        <div className=" mr-3 shopify-div  position-absolute ">
                <img src="/assets/images/kwikpass/publicApp.png" className="position-absolute shopify-sec-img" alt="" />
                <h3 className="position-absolute shopify-sec-head ">Shopify Public App</h3>
                <div className="position-absolute shopify-sec-text ">One-click integration for Shopify merchants to enable customer identification and engagement.</div>
            </div>

            <div className=" mr-3 position-absolute store-div">
                <img src="/assets/images/kwikpass/store.png" className="position-absolute store-sec-img" alt="" />
                <h3 className="position-absolute store-sec-head d-inline ">Shopify Custom Stores</h3>
                <div className="position-absolute store-sec-text ">Supports tailored Shopify implementations, ensuring seamless login and pop-up functionality.</div>
            </div>    

            
            <div className=" mr-3 position-absolute appmaker-div">
                <img src="/assets/images/kwikpass/appmaker.png" className="position-absolute appmaker-sec-img" alt="" />
                <h3 className="position-absolute appmaker-sec-head d-inline ">Appmaker & Appbrew</h3>
                <div className="position-absolute appmaker-sec-text ">Enables brands using these platforms to enhance user identification and  <br/>  marketing pop-ups.</div>
            </div>    

            <div className=" mr-3 position-absolute customweb-div">
                <img src="/assets/images/kwikpass/customweb.png" className="position-absolute customweb-sec-img" alt="" />
                <h3 className="position-absolute customweb-sec-head d-inline ">Custom-Built Websites</h3>
                <div className="position-absolute customweb-sec-text ">Easily integrates with any proprietary website to power secure user  <br/> authentication and engagement.</div>
            </div>   

             <div className="mr-3 position-absolute mobileApp-div">
                <img src="/assets/images/kwikpass/mobileApp.png" className="position-absolute mobileApp-sec-img" alt="" />
                <h3 className="position-absolute mobileApp-sec-head d-inline ">Android Mobile App</h3>
                <div className="position-absolute mobileApp-sec-text ">Extends seamless login and engagement capabilities to mobile- <br/>first businesses.</div>
            </div>  
      

          </div> 
        <div className="diagonal-line right-top"></div>
        <div className="diagonal-line right-bottom"></div>
      </div> */}

      {/* KwikPass Box */}
{/*    
        <div className="powering-details mt-5 mx-5">
          <h1>Kwik</h1>
          <img src="/assets/images/kwikpass/thunderLogo.png" style={{height:"auto",width:"26px"}} alt="Thunder Logo" />
          <h1>Pass</h1>
        </div> */}

    </div>

    <div className="container-fluid fourth d-flex justify-content-center align-items-center">

    <div className="top-text  text-center">

        <div className="btn">
          <a href="../contact">
            <button className="cta">Book a Demo</button>
          </a>
          <a href="https://apps.shopify.com/kwikpass">
            <button className="cta2 text-white">
              <img
                src="/assets/images/kwikpass/shop.png"
                alt="Shopify Logo"
                width={20}
              />
              Get It On Shopify
            </button>
          </a>
        </div>

    </div>

</div>

        <div className="container-fulid fourth mb-5">

            <div className="top-text growth">
              <h1>Identify | Engage | Convert  <br/>
              The Smarter Way to Recognize Every Shopper</h1>
              <p className="mt-4 mb-5">
              With Kwik Pass, the most advanced website visitor tracking app, every click counts toward higher <br/> growth.
              </p>
            </div>


            {/* Solution 1 */}

            {/* <Slider {...fullImageSliderSettings}>
              {sections1.map((slide, index) => (
                <div key={index}>
                  <img
                    src={slide.image}
                    // alt={slide.alt}
                    className="img-fluid d-block w-100"
                    style={{}}
                  />
                </div>
              ))}
            </Slider> */}

            {/* Solution 2 */}

           

            <div className="">
              {isMobile ? (
                 // ✅ MOBILE VIEW — only slider
              <div style={{ width: '100%', maxWidth: '100%', padding: '0 5px' }}>
              <Slider {...fullImageSliderSettings}>
                <div>
                  <img src="/assets/images/kwikpass/group1.png" alt="Banner 1" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/group2.png" alt="Banner 2" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/group3.png" alt="Banner 3" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/group4.png" alt="Banner 3" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikpass/group5.png" alt="Banner 3" className="slide-ban-image " />
                </div>
              </Slider>
            </div>
              ) : (
                // ✅ DESKTOP VIEW — animated image banners
                <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ 
          clickable: true,
          dynamicBullets: true 
        }}
        // navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        {sections1.map((section) => (
          <SwiperSlide key={section.id}>
            <div className="slide-wrapper">
              <img 
                className="slide-image" 
                src={section.image} 
                alt={`slide_image_${section.id}`} 
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '500px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
              )}
            </div>
            </div>       
           {/* <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ 
          clickable: true,
          dynamicBullets: true 
        }}
        // navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        {sections1.map((section) => (
          <SwiperSlide key={section.id}>
            <div className="slide-wrapper">
              <img 
                className="slide-image" 
                src={section.image} 
                alt={`slide_image_${section.id}`} 
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '500px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      
 */}

           



         {/* <div className="row cards-row">
              <div className="col-12">
          <div className="cards" ref={cardsRef}>
            <div className="custom-card card1" style={{ backgroundColor: 'darkcyan', zIndex: 2 }}>
              <h1>Slide 1</h1>
            </div>
            <div className="custom-card card2" style={{ backgroundColor: 'aliceblue', zIndex: 3 }}>
              <h1>Slide 2</h1>
            </div>
            <div className="custom-card card3" style={{ backgroundColor: 'green', zIndex: 4 }}>
              <h1>Slide 3</h1>
            </div>
          </div>
              </div>
            </div> */}
{/* 
        {
            isMobile ? 
           ( <div className="d-flex justify-content-center mt-5 mb-5">
            <Slider {...settingsmob}>
              {imagePaths.map((imagePath, index) => (
                <div key={index}>
                  <img src={imagePath} className="img-fluid" alt={`group${index + 1}`} />
                </div>
              ))}
            </Slider>
          </div> ):( <div className="d-flex justify-content-center mt-5" style={{marginBottom:"80px"}}>
                      <img src="/assets/images/kwikpass/group1.png" className="img-fluid" alt="group1" />
                  </div>)

        } */}

{/* <div style={{ background: "black", position: "relative", height: "300vh" }}>
      {sections1.map((section, index) => (
        <div
          key={section.id}
          style={{
            width: "100%",
            height: "100vh",
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            background: `url(${section.image}) no-repeat center center/cover`,
            zIndex: index,
            transform: `translateY(${activeIndex1 >= index ? "0" : "100%"})`,
            transition: "transform 0.8s ease-in-out",
          }}
        >
          
        </div>
      ))}
    </div> */}



    



      </div>
    </div>
  );
};
